<app-menu-crud-panel-bot [btns]="btnsL" [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">
</app-menu-crud-panel-bot>